import { DiToken, registerDiToken } from '@v2/utilities/di/di-token';

export type Environment = {
  brandName: string;
  locale: string;
  language: string;
  device: 'web' | 'mobile-web';
  environment: 'staging' | 'production';
  localServer: boolean;
};

export const ENVIRONMENT: DiToken<Environment> = new DiToken<Environment>('Environment');

export function registerEnvironment(env: Environment): void {
  registerDiToken(ENVIRONMENT, () => env);
}
